/**
 * Enum đã ghi sổ
 * dqvinh 11.11.2022
 */
export default {
  UnPosted: 0,
  Posted: 1,
};
